import React, { memo } from 'react';
import { Sword, Target, Trophy, Shield, TrendingUp, Activity, Star, BarChart3 } from 'lucide-react';

interface StatsGridProps {
  stats: {
    totalMatches: number;
    finishes: number;
    winnings: number;
    defaultTier: string;
  };
}

// memo prevents unnecessary re-renders
const StatsGrid = memo(({ stats }: StatsGridProps) => {
  const formatINR = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const statItems = [
    { icon: Sword, label: 'Matches', value: stats.totalMatches, color: 'text-purple-400', subIcon: TrendingUp },
    { icon: Target, label: 'Finishes', value: stats.finishes, color: 'text-yellow-500', subIcon: Activity },
    { icon: Trophy, label: 'Won', value: formatINR(stats.winnings), color: 'text-yellow-500', subIcon: Star },
    { icon: Shield, label: 'Tier', value: stats.defaultTier, color: 'text-purple-400', subIcon: BarChart3 },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {statItems.map((item, index) => (
        <div
          key={index}
          className="bg-gradient-to-br from-[#1a1a2e] to-[#0a0a0f] rounded-2xl p-4 border border-white/10 hover:border-purple-500/30 transition-all duration-300"
        >
          <div className="flex items-center justify-between mb-2">
            <item.icon className={`w-5 h-5 ${item.color}`} />
            {item.subIcon && <item.subIcon className="w-4 h-4 text-green-400 opacity-0 group-hover:opacity-100 transition" />}
          </div>
          <p className="text-gray-400 text-xs mb-1">{item.label}</p>
          <p className="text-white font-rajdhani font-bold text-2xl">{item.value}</p>
        </div>
      ))}
    </div>
  );
});

StatsGrid.displayName = 'StatsGrid';
export default StatsGrid;